import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "form-group"
}
const _hoisted_3 = {
  key: 0,
  class: "list-group-item"
}
const _hoisted_4 = { class: "list-group-item-heading" }
const _hoisted_5 = ["title", "onClick"]
const _hoisted_6 = { class: "text-secondary" }
const _hoisted_7 = {
  key: 0,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_btn = _resolveComponent("btn")!
  const _component_project_picker = _resolveComponent("project-picker")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_btn, {
      class: _normalizeClass(_ctx.btnClass),
      size: _ctx.btnSize,
      type: _ctx.btnType,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalOpen = true))
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _cache[5] || (_cache[5] = _createTextVNode("Choose A Job …", -1))
        ])
      ]),
      _: 3
    }, 8, ["class", "size", "type"]),
    _createVNode(_component_modal, {
      ref: "modal",
      modelValue: _ctx.modalOpen,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalOpen) = $event)),
      title: 'Choose A Job',
      "append-to-body": "",
      size: _ctx.size
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_btn, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalOpen = false))
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.showProjectSelector)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _cache[6] || (_cache[6] = _createElementVNode("label", null, "Project:", -1)),
              _createVNode(_component_project_picker, {
                modelValue: _ctx.project,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.project) = $event))
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showScheduledToggle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _withDirectives(_createElementVNode("select", {
                id: "_job_config_picker_scheduled_filter",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterType) = $event)),
                class: "form-control"
              }, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("option", { value: "" }, "All Jobs", -1),
                _createElementVNode("option", { value: "scheduled" }, "Scheduled Jobs", -1),
                _createElementVNode("option", { value: "notscheduled" }, "Non-Scheduled Jobs", -1)
              ]))], 512), [
                [_vModelSelect, _ctx.filterType]
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobTree.groups, (item, name) => {
          return (_openBlock(), _createElementBlock("div", {
            key: 'group' + name,
            class: "list-group"
          }, [
            (name && item.jobs.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("h4", _hoisted_4, _toDisplayString(item.label), 1)
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.jobs, (job) => {
              return (_openBlock(), _createElementBlock("div", {
                key: job.id,
                class: "list-group-item",
                style: {"overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
              }, [
                _createElementVNode("a", {
                  href: "#",
                  class: "",
                  title: 'Choose this job: ' + job.id,
                  onClick: ($event: any) => (_ctx.selectJob(job))
                }, [
                  _cache[8] || (_cache[8] = _createElementVNode("i", { class: "glyphicon glyphicon-book" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(job.name), 1)
                ], 8, _hoisted_5),
                _createElementVNode("span", _hoisted_6, _toDisplayString(job.description), 1),
                (job.scheduled)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("i", { class: "glyphicon glyphicon-time" }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "size"])
  ]))
}